import React, { useState } from "react";
import { Modal, Form, Row, Col, Input, message } from "antd";

import { FormComponentProps } from "antd/lib/form";
import { IKnowledgeType } from "./types";
import { saveOrUpdate } from "../actions/dimensionsAndType";
const { TextArea } = Input;

interface IProps extends FormComponentProps {
    record?: IKnowledgeType;
    onClose: (reload?: boolean) => void;
}

function FormKnowledgeType({ record, form, onClose }: IProps) {
    const [isSaving, setIsSaving] = useState(false);

    function handleOk() {
        form.validateFields((err, values) => {
            if (!err) {
                setIsSaving(true);

                const objToSave = { ...values };

                if (record) {
                    objToSave.id_tipo_conhecimento = record.id_tipo_conhecimento;
                }

                const data = JSON.stringify({
                    tipo_conhecimento: {
                        ...objToSave,
                    },
                });

                saveOrUpdate({
                    accao: "guardar",
                    formulario: "qa_tipos_conhecimentos.xml",
                    dados: data,
                })
                    .then((sucess) => {
                        if (sucess) {
                            message.success("Guardado");
                            onClose(true);
                        } else {
                            message.error("Ocorreu um erro");
                            setIsSaving(false);
                        }
                    })
                    .catch(() => {
                        message.error("Ocorreu um erro");
                        setIsSaving(false);
                    });
            }
        });
    }

    const { getFieldDecorator } = form;
    const title = record ? "Editar tipo de conhecimento" : "Novo tipo de conhecimento";

    return (
        <Modal title={title} visible onOk={handleOk} onCancel={() => onClose()} width="50%" confirmLoading={isSaving}>
            <Form layout="vertical" onSubmit={handleOk}>
                <Row gutter={18}>
                    <Col xs={24} sm={24} md={24}>
                        <Form.Item label="Designação">
                            {getFieldDecorator("designacao", {
                                initialValue: record?.designacao,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório",
                                    },
                                ],
                            })(<Input />)}
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24}>
                        <Form.Item label="Descrição">
                            {getFieldDecorator("descricao", {
                                initialValue: record?.descricao,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório",
                                    },
                                ],
                            })(<TextArea rows={4} />)}
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}

export const WrappedFormKnowledgeType = Form.create<IProps>({
    name: "Knowledge-type",
})(FormKnowledgeType);
